import { createDomain, sample } from 'effector'
import { useStore } from 'effector-react'

import { authStore, http, User } from '~/shared/api'
import { sentryModel } from '~/shared/lib/sentry'
import { debtModel } from '../Debt'

export const domain = createDomain('entities.viewer')

/* Save token */
export const tokenSaved = domain.createEvent<string>()
export const saveTokenFx = domain.createEffect<string, void>({
  async handler(token) {
    authStore.saveToken(token)
  },
})
sample({
  clock: tokenSaved,
  target: saveTokenFx,
})

/* Clear token */
export const tokenCleared = domain.createEvent()
export const clearTokenFx = domain.createEffect({
  async handler() {
    authStore.clearToken()
  },
})
sample({
  clock: tokenCleared,
  target: clearTokenFx,
})

/* Save phone */
export const phoneSaved = domain.createEvent<string>()
export const savePhoneFx = domain.createEffect<string, void>({
  async handler(phone) {
    authStore.savePhone(phone)
  },
})
sample({
  clock: phoneSaved,
  target: savePhoneFx,
})

/* Clear phone */
export const phoneCleared = domain.createEvent()
export const clearPhoneFx = domain.createEffect({
  async handler() {
    authStore.clearPhone()
  },
})
sample({
  clock: phoneCleared,
  target: clearPhoneFx,
})

http.onUnauthorize(() => {
  tokenCleared()
  phoneCleared()
  sentryModel.clearUser()
})

/* Token */
export const $token = domain
  .createStore<string | null>(authStore.token)
  .on(tokenSaved, (_, token) => token)
  .on(tokenCleared, () => null)

export const $authenticated = $token.map<boolean>((token) => Boolean(token))

export const signOut = domain.createEvent()
export const logoutFx = domain.createEffect({
  async handler() {
    return User.logout()
  },
})

sample({
  clock: signOut,
  target: logoutFx,
})

sample({
  clock: logoutFx.doneData,
  target: [
    tokenCleared,
    phoneCleared,
    sentryModel.clearUser,
    debtModel.clearReport,
  ],
})

/* Hooks */
export const useAuthenticated = () => useStore($authenticated)
